import * as React from "react"
import { SVGProps, memo } from "react"

const ErrorTriangle = memo((props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        {...props}
    >
        <path
            d="M7.57 2.21L2.51 12.28C2.35683 12.5375 2.27476 12.8295 2.2715 13.1277C2.26823 13.4259 2.34388 13.7204 2.49131 13.9823C2.63874 14.2443 2.85298 14.4651 3.11376 14.6228C3.37454 14.7804 3.67347 14.8694 3.98 14.88H12.1C12.4047 14.8676 12.7009 14.7771 12.9591 14.6183C13.2173 14.4595 13.4289 14.238 13.5742 13.9759C13.7195 13.7138 13.7936 13.4202 13.7896 13.1229C13.7857 12.8256 13.7038 12.5341 13.55 12.277L8.49 2.21C8.3362 1.95565 8.119 1.74252 7.85742 1.59048C7.59585 1.43844 7.29785 1.35254 6.99289 1.34073C6.68792 1.32892 6.38513 1.39147 6.11034 1.52295C5.83555 1.65443 5.59707 1.85062 5.41586 2.09446C5.23466 2.3383 5.11634 2.62276 5.07 2.923L7.57 2.21Z"
            fill="#D02828"
            stroke="none"
        />
        <path
            d="M8 5V9M8 11H8.01"
            stroke="white"
            strokeWidth={1.5}
        />
    </svg>
))

export default ErrorTriangle